import { Content } from './content';

export class Profile extends Content {

    static tableName = 'profil-contents'

}